import { ArrowRight } from "@phosphor-icons/react";
import { Text } from "@radix-ui/themes";

interface SuggestedResponsesProps {
  suggestions: string[];
  onSelect: (suggestion: string) => void;
  disabled?: boolean;
}

export function SuggestedResponses({
  suggestions,
  onSelect,
  disabled,
}: SuggestedResponsesProps) {
  if (suggestions.length === 0) return null;

  return (
    <div
      className="flex animate-fade-in flex-wrap gap-2 px-3 pb-3 pt-2"
      data-testid="suggested-responses"
    >
      {suggestions.map((suggestion) => (
        <button
          key={suggestion}
          type="button"
          disabled={disabled}
          onClick={() => onSelect(suggestion)}
          data-testid="suggested-response-btn"
          className="group flex items-center gap-1.5 rounded-full border border-puntt-accent-5 bg-puntt-accent-2/50 px-4 py-2 shadow-sm transition-all duration-300 hover:-translate-y-px hover:border-puntt-accent-9 hover:bg-puntt-accent-2 hover:shadow-md disabled:cursor-not-allowed disabled:opacity-50"
        >
          <Text size="1" className="text-puntt-accent-11">
            {suggestion}
          </Text>
          <ArrowRight
            size={12}
            className="-translate-x-0.5 text-puntt-accent-9 opacity-0 transition-all group-hover:translate-x-0 group-hover:opacity-100"
          />
        </button>
      ))}
    </div>
  );
}
